module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"with-specifications":"Avec spécifications","linked-to-project-template":"Liés au gabarit de projet","project-template":"Gabarit de projet"},"en":{"with-specifications":"With specifications","linked-to-project-template":"Linked to project template","project-template":"Project template"}}')
  delete Component.options._Ctor
}
